import React, { Fragment, Component } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  CardImg,
  Col,
  Row,
  Table,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { MdEdit, MdDeleteForever } from "react-icons/md";

import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { getAuthUser } from "../GeneralFunctions";

import * as Server from "../Server";
import LinkEdit from "./LinkEdit";

let user = {};
let selectedLinkId = null;

class Links extends Component {
  constructor(props) {
    super(props);
    this.state = {
      link: {},
      links: [],
      editLink: false,
      showLoader: false,
      linkEditPage: false,
      removeLinkConfirmationModal: false,
    };
  }

  componentDidMount() {
    user = getAuthUser();
    this.getLinkDetails();
  }

  getLinkDetails = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/links/list",
        method: "POST",
        data: { clubId: user.connectedUser._id },
      });
      if (response) {
        this.setState({
          showLoader: false,
          links: response.links,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeLink = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `rushsoccer/links/delete?linkId=${selectedLinkId}`,
        method: "DELETE",
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
        this.getLinkDetails();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleremoveLinkConfirmationModal = async (id) => {
    if (id) selectedLinkId = id;
    this.setState({
      removeLinkConfirmationModal: !this.state.removeLinkConfirmationModal,
    });
  };

  renderLinkEditPage = (link, key) => {
    this.setState({
      link,
      linkEditPage: true,
      editLink: key,
    });
  };

  closeModal = async () => {
    this.setState({ removeLinkConfirmationModal: false });
  };

  closeLinkEditPage = async (obj) => {
    this.setState({ linkEditPage: false });
    this.getLinkDetails();
  };

  render() {
    return (
      <Fragment>
        {this.state.linkEditPage ? (
          <LinkEdit
            link={this.state.link}
            linkEditKey={this.state.editLink}
            closeLinkEditPage={(event) => this.closeLinkEditPage(event)}
          ></LinkEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page title="Link" breadcrumbs={[{ name: "Link", active: true }]}>
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader></CardHeader>
                    <CardBody>
                      <Button
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={(event) => this.renderLinkEditPage({}, false)}
                      >
                        Add Link
                      </Button>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Icon</th>
                            <th>Name</th>
                            <th>Url</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.links && this.state.links.length > 0 ? (
                            this.state.links.map((link, index) => (
                              <tr key={index}>
                                <td style={{ width: "25%" }}>
                                  <CardImg
                                    style={{ width: "50%" }}
                                    src={link.icon}
                                    alt=""
                                  ></CardImg>
                                </td>
                                <td>{link.name}</td>
                                <td>{link.url}</td>
                                <td>
                                  <Button
                                    style={{ marginRight: "10px" }}
                                    onClick={(event) => {
                                      this.renderLinkEditPage(link, true);
                                    }}
                                  >
                                    <MdEdit size="20px" />
                                  </Button>
                                  <Button
                                    style={{ marginRight: "10px" }}
                                    onClick={(event) =>
                                      this.toggleremoveLinkConfirmationModal(
                                        link._id
                                      )
                                    }
                                  >
                                    <MdDeleteForever size="20px" />
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No links found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                    {this.state.removeLinkConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeLinkConfirmationModal}
                        toggle={(event) =>
                          this.toggleremoveLinkConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleremoveLinkConfirmationModal()
                          }
                        ></ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this link ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleremoveLinkConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.toggleremoveLinkConfirmationModal();
                              this.removeLink();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}

export default Links;
